import { useEffect, useState } from 'react'
import { MemoryRouter } from 'react-router'
import { RetailerSatisfactionSurveyStep } from '../RetailerSatisfactionSurveyStep'
import { SurveyContextProvider } from '../RetailerSatisfactionSurveyContext'
import { useRetailerId, usePartnerId } from '../../../../utils/routing/params.hooks'
import { useTrackEvent } from '../../../../utils/events/useTrackEvent.hook'
import { NavV3OptOutSurveyModal } from './NavV3OptOutSurveyModal'
import { NavV3OptOutSurveyContent } from './NavV3OptOutSurveyContent'
import { NAV_V3_OPT_OUT_SURVEY_MILESTONE_SLUG } from './useNavV3OptOutSurveyAccess'
import { type NavV3OptOutSurveyOptionValue } from './NavV3OptOutSurveyData'

export enum NavV3OptOutSurveyPages {
  Page1 = 'page1',
}

export interface NavV3OptOutSurveyState {
  reason: NavV3OptOutSurveyOptionValue | ''
  additionalContext: string
}

export interface NavV3OptOutSurveyControllerProps {
  onClose: () => void
}

export interface NavV3OptOutSurveyProps {
  onClose: () => void
}

const defaultState: NavV3OptOutSurveyState = {
  reason: '',
  additionalContext: '',
}

export const NavV3OptOutSurveyController = ({ onClose }: NavV3OptOutSurveyControllerProps) => {
  const [surveyData, setSurveyData] = useState<NavV3OptOutSurveyState>(defaultState)
  const retailerId = useRetailerId({ throwOnMissing: false }) ?? '0'
  const partnerId = usePartnerId({ throwOnMissing: false }) ?? '0'
  const trackEvent = useTrackEvent()

  useEffect(() => {
    trackEvent({
      id: 'app.navV3.optOutSurvey.modal.viewed',
      description: 'Tracks whenever the nav v3 opt-out survey modal is viewed',
    })
  }, [trackEvent])

  return (
    <MemoryRouter initialEntries={[NavV3OptOutSurveyPages.Page1]}>
      <SurveyContextProvider
        toolProps={{ toolName: 'Nav V3 Opt-Out Survey', onClose }}
        milestoneSlug={NAV_V3_OPT_OUT_SURVEY_MILESTONE_SLUG}
        // Cast: SurveyContextProvider's surveyData is loosely typed as [{}, (x:any)=>void]
        surveyData={[surveyData, setSurveyData as (x: any) => void]}
        onSurveyCompleted={() => surveyData}
        retailerId={retailerId}
        partnerId={partnerId}
      >
        <NavV3OptOutSurveyModal>
          <RetailerSatisfactionSurveyStep
            name={NavV3OptOutSurveyPages.Page1}
            component={NavV3OptOutSurveyContent}
          />
        </NavV3OptOutSurveyModal>
      </SurveyContextProvider>
    </MemoryRouter>
  )
}
